import { css } from 'styled-components'

// NOTE: String interpolation with styled-components's css API does not work well.
const style = css`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-neutral-80);
  height: 35px;
  width: 100%;

  &:hover {
    background-color: #f7f1fd;
    span {
      color: #6e0ad6;
    }
  }
`

export default style
